<div class="progressbar">
  <div class="progressbar__header">
    <p class="progressbar__label">{{ 'catalog.card.funding_progress' | translateLang }}</p>
    <p class="progressbar__percentage">{{ percentage() }}%</p>
  </div>
  <div class="progressbar__track">
    <div class="progressbar__fill" [style.width.%]="percentage()"></div>
  </div>
  <div class="progressbar__footer">
    <p class="progressbar__raised">
      <span class="progressbar__raised-label">Raised :</span> {{ currency }}{{ currentValue() | gsNumberFormat:2 }}
    </p>
    <p class="progressbar__goal">
      <span class="progressbar__goal-label">Goal :</span> {{ currency }}{{ totalValue() | gsNumberFormat:2 }}
    </p>
  </div>
</div>
